import {
  GET_CLAIMS_FAILED,
  GET_CLAIMS_START,
  GET_CLAIMS_SUCCESS,
  SET_USER,
  UserClaims,
  UserProfileStore
} from './types';
import { Dispatch } from 'redux';
import axios from 'axios';
import { ReduxStore } from '../payload-types';
import { get } from 'lodash';
import { AUTH_HEADERS, LINKS } from '@trip-ux/constants';

export const setUser =
  (payload: Partial<UserProfileStore>) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: SET_USER,
      payload
    });
  };

export const getClaims =
  (payload: UserClaims) =>
  (dispatch: Dispatch, getState: () => ReduxStore): Promise<void> => {
    dispatch({ type: GET_CLAIMS_START, ...payload });
    const org = get(getState(),'config.options.organizationCode', 'CM');
    const distributor = get(getState(),'travellersDetails.agent', '');
    return axios
      .get(`${get(getState(), 'config.options.contextPath', '')}${LINKS.AUTH}`, {
        headers: {
          [AUTH_HEADERS.USER_REF]: payload.userRef,
          [AUTH_HEADERS.USER_TYPE]: payload.userType,
          [AUTH_HEADERS.DISTRIBUTOR_ORG]: org,
          [AUTH_HEADERS.DISTRIBUTOR_REF]: distributor,
          ...(payload.scope && { [AUTH_HEADERS.SCOPE]: payload.scope }),
          ...(payload.idToken && { [AUTH_HEADERS.ID_TOKEN]: payload.idToken })
        }
      })
      .then(({ data }) => {
        dispatch({ type: GET_CLAIMS_SUCCESS, payload: { ...data, ...payload } });
      })
      .catch(e => {
        dispatch({ type: GET_CLAIMS_FAILED, payload: e });
      });
  };
